module.exports = __webpack_public_path__ + "img/category_main_9.66b34373.jpg";